import { ReactComponent as CrossIcon } from 'assets/icon/x-circle.svg';
import { useAppDispatch, useAppSelector } from 'hooks/useAppDispatchSelector';
import { setModal } from 'store/features/modelSlice';
import { initModal } from 'helpers/utils';
import { ReactComponent as UserIcon } from 'assets/icon/user.svg';
import { useTranslation } from 'react-i18next';

const OfferNotifyUsers = () => {
  const dispatch = useAppDispatch();
  const {
    modal: {
      content: { title },
    },
  } = useAppSelector(state => state.modal);
  const { t } = useTranslation();
  const { offerNotifyUsers } = useAppSelector(state => state.alerts);

  return (
    <div className="flex flex-col max-w-[500px] w-[500px] max-h-[calc(100vh-250px)] gap-y-4 overflow-hidden">
      <div className="flex items-center w-full">
        <div className="flex flex-wrap items-center flex-1">
          <label className="pl-2 text-xl font-semibold text-black2 w-full line-clamp-1">
            {t('NOTIFY_USERS')}
          </label>
          <label className="pl-2 text-sm font-medium text-grey3 w-full line-clamp-1">{title}</label>
        </div>
        <div
          className="flex items-center justify-center cursor-pointer"
          onClick={() => dispatch(setModal(initModal))}
        >
          <CrossIcon height={32} width={32} />
        </div>
      </div>
      <div className="flex flex-wrap w-full overflow-y-auto flex-1 gap-y-1">
        {offerNotifyUsers.length ? (
          offerNotifyUsers.map(data => (
            <div
              className="flex w-full border-b-1 px-2 py-3 hover:bg-grey8 gap-x-2"
              key={data?._id}
            >
              <div className="flex items-center justify-center h-10 w-10 bg-grey6 p-2 rounded-full">
                <UserIcon height={24} width={24} />
              </div>
              <div className="flex flex-wrap flex-1">
                <label className="font-semibold text-sm w-full">{`${data?.name} ${data?.surname}`}</label>
                <label className="font-regular text-xs w-full line-clamp-1">{data?.email}</label>
              </div>
            </div>
          ))
        ) : (
          <div className="flex items-center justify-center bg-grey4 rounded-4 p-4 w-full mt-4">
            <label className="flex items-center justify-center w-full text-center font-medium">
              {t('NO_USERS')}
            </label>
          </div>
        )}
      </div>
    </div>
  );
};

export default OfferNotifyUsers;
